export default "__VITE_ASSET__D42G_YOX__"